import { createFileRoute } from "@tanstack/react-router";
import { FormRulesTabPanel } from "@/features/form-editor/components/form-rules-tab-panel";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/full/form/rules",
)({
	component: FormRulesTabPanel,
});
